import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { Review } from '../../../models/review.model';
import { BaseComponent } from '../../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../services/guard/auth.service';
import { ReviewService } from 'src/services/review.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent extends BaseComponent implements OnInit {
  @Input() review: Review;
  @Output() reviewDeleted: EventEmitter<boolean> = new EventEmitter();
  _showResponse: boolean;
  modalRef: BsModalRef;
  reviewModel: Review;
  locale: string;

  constructor(
    translate: TranslateService,
    authService: AuthService,
    private reviewService: ReviewService,
    private toast: ToastrService,
    private modalService: BsModalService,
    private router: Router,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.langChange.subscribe(() => this.ngOnInit());
  }

  ngOnInit(): void {
    if (this.translate.currentLang === 'fr') {
      this.locale = 'fr-FR';
    } else {
      this.locale = 'en-US';
    }
  }

  getMonth(date: Date) {
    return new Date(date).toLocaleString(this.locale, { month: 'long' });
  }

  showResponse() {
    this._showResponse = !this._showResponse;
  }

  answerModal(template: TemplateRef<any>) {
    this.reviewModel = new Review();
    this.reviewModel = Object.assign({}, this.review);
    this.modalRef = this.modalService.show(template);
  }

  saveReview() {
    this.reviewService.updateReview(this.reviewModel).subscribe(
      () => this.toast.success('Review updated!'),
      err => {
        console.error(err);
        this.toast.error('An error occured');
      },
      () => {
        this.review = this.reviewModel;
        this.close();
      }
    );
  }

  deleteReview() {
    this.confirm.confirm({
      message: 'Are you Sure?',
      accept: () => {
        this.reviewService.deleteReview(this.review).subscribe(
          () => this.toast.success('Review deleted!'),
          err => {
            console.error(err);
            this.toast.error('An error occured');
          },
          () => this.reviewDeleted.emit(true)
        );
      }
    });
  }

  close() {
    this.modalRef.hide();
  }

}
